export const ROUTES_MAPPING = {
  contacts: '/',
  committee: '/committee',
  contactDetails: '/contact/:contactId',
  announcements: '/announcements',
  admin: '/admin',
} as const;